import { Link } from "gatsby";
import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/services-usa/game_update/banner_bg.webp";

function Banner() {
  // Function to handle the scroll action
  const scrollToCaseStudies = () => {
    const caseBtnElement = document.getElementById("case_btn");
    if (caseBtnElement) {
      // Using `scrollIntoView` to scroll to the target element
      caseBtnElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <section
      className="game_banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
            <h1>Top-Tier Mobile Game Development Company</h1>
            <p>
              TekRevol is a leading mobile game development company that
              develops high-quality 2D and 3D interactive mobile games for iOS
              and Android, with awe-inspiring graphics, smooth gameplay,
              fascinating storyline, and more!
            </p>
            <div className="banner_btn">
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Lets Build Your Game App
              </Link>
              <button
                className="border_btn web_case_btn"
                aria-label="TekRevol Contact"
                onClick={scrollToCaseStudies}
              >
                Case Studies
              </button>
            </div>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="mt-auto offset-lg-1"
          >
            <div className="game_main_img">
              <StaticImage
                src="../../images/services-usa/game_update/game_img.webp"
                alt="tekrevol_game_development"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={628}
                height={921}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
